import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'sd-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: [
    './modal-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalHeaderComponent implements OnInit {
  isMobileOrTablet = false;
  constructor(deviceService: DeviceDetectorService) {
    this.isMobileOrTablet = !deviceService.isDesktop();
  }

  ngOnInit() {
  }

}
